import renderLifeInsuranceAdvancedConfigModal from "../../../infrastructure/renders/LifeInsuranceAdvancedConfigModal/render-life-insurance-advanced-config-modal";
import { findCompanyDetail } from "../../../infrastructure/repository/company-repository";
import { configLifeInsurance } from "../../../infrastructure/repository/life-insurance-repository";
import { hideModal } from "../../commons/hide-modal";
import { showErrorMessage } from "../../commons/show-error-message";
import { translate as t } from "../../../infrastructure/translate/localization";
import { displayBenefitPage } from "../displays/display-benefit-page";

export default async function configLifeInsuranceBenefit({ selectedTab }) {
  const { data } = await findCompanyDetail();
  renderLifeInsuranceAdvancedConfigModal({
    benefitModel: selectedTab,
    config: data.lifeInsurancePolicies
      .map(({ modalities }) => modalities)
      .reduce((acc, curr) => [...acc, ...curr], [])
      .map(({ modalityId, ...rest }) => {
        const equivalentInConfig = selectedTab.lifeInsuranceConfigs.find(
          ({ modalityId: id }) => id === modalityId
        );
        if (equivalentInConfig) {
          return { ...equivalentInConfig, ...rest };
        }
        return null;
      })
      .map(({ capitals, capitalConfigs, ...rest }) => ({
        capitalConfigs: capitalConfigs.map((capital) => ({
          ...capital,
          ...capitals.find(({ capitalId }) => capitalId === capital.capitalId),
        })),
        ...rest,
      })),
    callback: async (payload) => {
      try {
        await configLifeInsurance(payload);
        hideModal();
        displayBenefitPage(selectedTab.id);
      } catch (err) {
        showErrorMessage(t("common-messages.basic-error-message"));
      }
    },
  });
}
